import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash/fp';

import { ValidationError, ValidationErrors } from './styles';

const ItemSelectorValidationErrors = ({
  errors,
}) => (
  <ValidationErrors>
    {
      map(error => (
        <ValidationError key={error}>
          {error}
        </ValidationError>
      ), errors)
    }
  </ValidationErrors>
);
ItemSelectorValidationErrors.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string).isRequired,
};
export default ItemSelectorValidationErrors;
